
































import { Component, Vue, Ref, Watch, Mixins } from 'vue-property-decorator'
import SidebarSwitcher from '@/components/organisms/v2/SidebarSwitcher.vue'
import StudentInformationTimeline from '@/components/organisms/StudentInformationTimeline.vue'
import CheckboxWithLabel from '@/components/molecules/CheckboxWithLabel.vue'
import RangeDatePicker from '@/components/molecules/RangeDatePicker.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import Conditions from '@/components/organisms/Conditions.vue'
import moment from 'moment'
import LocalMoment from '@/components/atoms/LocalMoment.vue'
import ClassModeChangeAble from '@/mixins/student/ClassModeChangeAble'

export type Condition = {
  label: string
  name: string
  key: string
  value: string
}

@Component({
  components: {
    SidebarSwitcher,
    StudentInformationTimeline,
    CheckboxWithLabel,
    RangeDatePicker,
    ButtonBase,
    Conditions,
  },
})
export default class Timeline extends Mixins(LocalMoment, ClassModeChangeAble) {
  private menuOpen(): void {
    this.isMenuOpened = true
  }

  private menuClose(): void {
    this.isMenuOpened = false
  }

  private isMenuOpened = false

  private conditions: Condition[] = []

  private timelineData = []

  private lastData: any = {}

  private learningTypeDatas: object[] = [
    { label: '通常', value: 'TJ' },
    { label: '対策', value: 'TK' },
    { label: '講習', value: 'KS' },
    { label: '入試', value: 'NY' },
    { label: '補助', value: 'HJ' },
    { label: '間違', value: 'MN' },
    { label: 'AI', value: 'AI' },
  ]

  private subjectDatas: object[] = [
    { label: '算数/数学', value: 'su' },
    { label: '英語', value: 'ei' },
    { label: '国語', value: 'ko' },
    { label: '社会', value: 'sh' },
    { label: '理科', value: 'ri' },
  ]

  private learningMaterialDatas: object[] = [
    { label: '確認テスト', value: 'KK' },
    { label: '導入動画', value: 'EZ' },
    { label: '理解度テスト', value: 'RK' },
    { label: '演習', value: 'EN' },
    { label: '宿題', value: 'SY' },
    { label: '動画（補助教材）', value: 'HD' },
    { label: '練習（補助教材）', value: 'HR' },
    { label: 'テスト（補助教材）', value: 'HT' },
    { label: '間違い直し', value: 'MN' },
  ]

  @Ref() rangeDatePicker!: RangeDatePicker

  private observer!: IntersectionObserver
  @Ref() observeElement!: HTMLElement

  private async mounted(): Promise<void> {
    await this.checkClassModeAndSideMenuMode()
    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        if (entry && entry.isIntersecting && Object.keys(this.lastData).length) {
          // 追加取得
          this.loadDatas()
        }
      },
      { rootMargin: '200px 0px' }
    )
    this.observer.observe(this.observeElement)
    // クッキーに検索条件が存在する場合はセットする
    const conditions = Vue.prototype.$cookies.get('dataGdls').timelineConditions
    if (conditions) {
      this.restoreConditions(conditions)
    } else {
      this.select()
    }
  }

  private async loadDatas() {
    const params = this.conditions.reduce((accumlator: any, condition: any): any => {
      accumlator[condition.key] = condition.value
      return accumlator
    }, {})

    // 期間開始に最終レコードの学習開始日時を設定
    if (this.lastData.startedAt) params.startedAtLteq = this.lastData.startedAt

    // TODO: 生徒アイコンは未定、無限スクロール対応は後回し
    await Vue.prototype.$http.httpWithToken
      .post('/timelines', { q: params, lastData: this.lastData })
      .then((res: any) => {
        const add_timelines: [] = res.data.timelines.map((timeline: any) => {
          return {
            id: timeline.studentCode,
            name: timeline.nickname,
            icon: '',
            school: timeline.schoolName,
            grade: timeline.gradeName,
            date: timeline.studyDate,
            time: timeline.studyTime,
            type: timeline.studyType,
            item_text: timeline.lessonName,
            material: timeline.lessonType,
            study_time: timeline.duration,
            study_count: timeline.completeCount,
            result: { all: timeline.questionCount, correct: timeline.correctCount },
            learningFlag: timeline.learningFlag,
            resultDrillId: timeline.resultDrillId,
            resultDrillVersion: timeline.resultDrillVersion,
          }
        })
        this.timelineData.push(...add_timelines)
        this.lastData = res.data.meta.lastData
        // 最終行の場合、監視終了
        if (!add_timelines.length) this.observer.disconnect()
      })
  }

  private clear() {
    this.rangeDatePicker.startDatePickerBase.selectedDate = this.beforeDays(14).toDate()
    this.rangeDatePicker.endDatePickerBase.selectedDate = null
    this.learningTypeDatas.forEach((data: any) => {
      data.checked = false
    })
    this.subjectDatas.forEach((data: any) => {
      data.checked = false
    })
    this.learningMaterialDatas.forEach((data: any) => {
      data.checked = false
    })
  }

  private select() {
    const conditionsDatas = []

    // 期間開始
    const startDate = this.rangeDatePicker.startDatePickerBase.selectedDate
    if (startDate) {
      conditionsDatas.push({
        label: '期間開始',
        name: moment(startDate).format('YYYY/MM/DD'),
        key: 'startedAtGteq',
        value: moment(startDate).startOf('day').format('YYYY/MM/DD HH:mm:ssZ'),
      })
    }

    // 期間終了
    const endDate = this.rangeDatePicker.endDatePickerBase.selectedDate
    if (endDate) {
      conditionsDatas.push({
        label: '期間終了',
        name: moment(endDate).format('YYYY/MM/DD'),
        key: 'startedAtLteq',
        value: moment(endDate).endOf('day').format('YYYY/MM/DD HH:mm:ssZ'),
      })
    }

    // 学習種別
    this.addCheckBoxConditionData(conditionsDatas, this.learningTypeDatas, '学習種別', 'classModes')

    // 教科
    this.addCheckBoxConditionData(conditionsDatas, this.subjectDatas, '教科', 'subjects')

    // 学習教材
    this.addCheckBoxConditionData(conditionsDatas, this.learningMaterialDatas, '学習教材', 'classCategories')

    this.conditions = conditionsDatas
    this.setTimelineCookie()
    this.menuClose()
  }

  private addCheckBoxConditionData(conditionsDatas: any, checkBoxDatas: any, label: string, key: string) {
    const selectedDatas = checkBoxDatas.filter((data: any) => data.checked)
    if (selectedDatas.length > 0) {
      conditionsDatas.push({
        label: label,
        name: selectedDatas.map((data: any) => data.label).join('、'),
        key: key,
        value: selectedDatas.map((data: any) => data.value),
      })
    }
  }

  private removeConditions(label: string) {
    if (label === '期間開始') this.rangeDatePicker.startDatePickerBase.selectedDate = null
    if (label === '期間終了') this.rangeDatePicker.endDatePickerBase.selectedDate = null
    if (label === '学習種別') {
      this.learningTypeDatas.forEach((data: any) => {
        data.checked = false
      })
    }
    if (label === '教科') {
      this.subjectDatas.forEach((data: any) => {
        data.checked = false
      })
    }
    if (label === '学習教材') {
      this.learningMaterialDatas.forEach((data: any) => {
        data.checked = false
      })
    }

    this.conditions = this.conditions.filter((condition: { label: string }) => condition.label !== label)
    this.setTimelineCookie()
  }

  private async setTimelineCookie() {
    // クッキーに検索条件をセット
    const cookie = Vue.prototype.$cookies.get('dataGdls')
    cookie['timelineConditions'] = this.conditions
    await Vue.prototype.$cookies.set('dataGdls', cookie, Function(`return (${process.env.VUE_APP_COOKIE_EXPIRE})`)())
  }

  private restoreConditions(conditions: Condition[]) {
    this.conditions = conditions
    const start = conditions.find((condition: { label: string }) => condition.label === '期間開始')
    if (start) {
      this.rangeDatePicker.startDatePickerBase.selectedDate = new Date(start.value)
    } else {
      this.rangeDatePicker.startDatePickerBase.selectedDate = null
    }
    const end = conditions.find((condition: { label: string }) => condition.label === '期間終了')
    if (end) {
      this.rangeDatePicker.endDatePickerBase.selectedDate = new Date(end.value)
    }
    const lerningType = conditions.find((condition: { label: string }) => condition.label === '学習種別')
    if (lerningType) {
      this.learningTypeDatas.forEach((data: any) => {
        data.checked = lerningType.value.includes(data.value)
      })
    }
    const subject = conditions.find((condition: { label: string }) => condition.label === '教科')
    if (subject) {
      this.subjectDatas.forEach((data: any) => {
        data.checked = subject.value.includes(data.value)
      })
    }
    const learningMaterial = conditions.find((condition: { label: string }) => condition.label === '学習教材')
    if (learningMaterial) {
      this.learningMaterialDatas.forEach((data: any) => {
        data.checked = learningMaterial.value.includes(data.value)
      })
    }
  }

  @Watch('conditions', { deep: true })
  private conditionsChange() {
    // 条件が設定された時の初回取得
    this.timelineData = []
    this.lastData = {}
    this.loadDatas()
    this.observer.observe(this.observeElement)
  }
}
